module.exports = __webpack_public_path__ + "img/back.cb0e2d5d.svg";